import { Injectable } from '@angular/core';
import { Routes } from '../../config/routes';
import { JwtLegFiClaims } from './jwt-legfi-claims.model';
import { ApplicationHttpClient } from '../../components/shared/http/application-http-client';
import { LegFiJwtService } from './legfi-jwt.service';
import { Observable } from 'rxjs';
import { CalendarEvent } from '../../models/entities/calendar-event';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class OAuthService
{
    private _http: ApplicationHttpClient;

    constructor(_http: ApplicationHttpClient) {
        this._http = _http;
    }

    public generateStateHash(request: object): Observable<Object> {
        return this._http.post(
                Routes.MakeLegFiCoreUrl(
                        Routes.LegFiCore.OAuthState(),
                ),
                JSON.stringify(request),
        );
    }

    /**
     * @param {number} organizationId
     * @param {object} request
     * @returns {Observable<Object>}
     */
    public sendAuthRequest(request: object): Observable<Object> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();

        return this._http.post(
                Routes.MakeLegFiCoreUrl(
                        Routes.LegFiCore.GoogleOAuth(jwt.orgId),
                ),
                JSON.stringify(request),
        );
    }

    public checkGoogleSigninStatus(): Observable<Object> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();

        return this._http.get(
                Routes.MakeLegFiCoreUrl(
                        Routes.LegFiCore.GoogleOAuth(jwt.orgId),
                ),
        );
    }

    public getGoogleCalendarList(): Observable<Object> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();

        return this._http.get(
                Routes.MakeLegFiCoreUrl(
                        Routes.LegFiCore.GoogleCalendarList(jwt.orgId),
                ),
        );
    }

    public getGoogleCalendarEvents(): Observable<CalendarEvent[]> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();

        return this._http.get(
                Routes.MakeLegFiCoreUrl(
                        Routes.LegFiCore.GoogleCalendar(jwt.orgId),
                ),
        ).pipe(map(
                (response: Object[]) => {
                    return response.map(
                            (calEvent) => {
                                return new CalendarEvent(calEvent);
                            },
                    );
                },
        ));
    }

    public updateActiveGoogleCalendar(request: object): Observable<Object> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        return this._http.post(
                Routes.MakeLegFiCoreUrl(
                        Routes.LegFiCore.OrganizationOAuthSettings(jwt.orgId),
                ),
                JSON.stringify(request),
        );
    }

    public logoutGoogle(): Observable<Object> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();

        return this._http.get(
                Routes.MakeLegFiCoreUrl(
                        Routes.LegFiCore.GoogleOAuthSignout(jwt.orgId),
                ),
        );
    }
}
